import React, { lazy } from "react";
import { useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const Verify = lazy(() => import("./pages/Verify"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const EditBattle = lazy(() => import("./pages/ViewUser"));
const Forgot = lazy(() => import("./pages/forgot"));
const ChangePass = lazy(() => import("./pages/changePass"));

function App() {
  let AccToken = useSelector((state) => state.token);
  return (
    <>
  
      <Router 
      basename={process.env.REACT_APP_WEB_PLATFORM_HOMEPAGE}
      >
        <AccessibleNavigationAnnouncer />
        {!AccToken ? (
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/forgot" component={Forgot} />
            <Route path="/changePassword" component={ChangePass} />
            <Redirect exact from="/" to="/login" />
          </Switch>
        ) : (
          <Switch>
            <Route path="/" component={Layout} />
          </Switch>
        )}
      </Router>
    </>
  );
}

export default App;
